import React from "react";

interface IconProps {
    className?: string;
  }

const MiniDisplayIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    id="Layer_1"
    height="512"
    viewBox="0 0 24 24"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    className={className}
  >
    <g id="Mini_Player" data-name="Mini Player">
      <path d="m19 4h-14a3.009 3.009 0 0 0 -3 3v10a3.009 3.009 0 0 0 3 3h14a3.009 3.009 0 0 0 3-3v-10a3.009 3.009 0 0 0 -3-3zm-2 13h-4a2.006 2.006 0 0 1 -2-2v-2a2.006 2.006 0 0 1 2-2h4a2.006 2.006 0 0 1 2 2v2a2.006 2.006 0 0 1 -2 2z" />
    </g>
  </svg>
);

export default MiniDisplayIcon;
